// @flow

import type { FormError } from "../types/form";

export const isError = (meta: FormError) =>
  (meta.error || meta.submitError) && meta.touched;

export const errorMessage = (meta: FormError) => meta.error || meta.submitError;
